import Script from 'next/script'

interface GoogleOneTapProps {
  market: string
  domain: string
  endpoint: string
  host: string
  isTablet?: boolean
}

const GoogleOneTap: React.FC<GoogleOneTapProps> = ({ market, domain, endpoint, host, isTablet }) => {
  // Market'e göre doğru client ID ve login URI'yi belirle
  const isEnuygun = domain?.includes('enuygun') || market === 'tr'

  const clientId = isEnuygun
    ? '342871572439-55khvmsqhir7udak0ocfh58q2mvh1tu4.apps.googleusercontent.com' // Enuygun
    : '811576610759-pobr5voquhmp2sqf7qimpo3l1ig9uoin.apps.googleusercontent.com' // Wingie

  const basePath = isEnuygun ? '/uyelik' : '/account'
  const baseUrl = market === 'tr' ? host : endpoint
  const loginUri = `${baseUrl}${basePath}/member/hwi/google_one_tap`

  return (
    <>
      <Script src="https://accounts.google.com/gsi/client" strategy="afterInteractive" />
      <div
        id="g_id_onload"
        data-client_id={clientId}
        data-login_uri={loginUri}
        data-context="signin"
        data-ux_mode="popup"
        data-cancel_on_tap_outside="false"
        data-auto_select="false"
        data-itp_support="true"
      />
    </>
  )
}

export default GoogleOneTap
